import React from "react";

export default function Privacy() {
  return (
    <div className="w-full">
      {/* Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage:
            "url('/images/privacy.webp')", // Add a banner image inside /public/images/
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Privacy
        </h1>
      </div>
    <div className="max-w-5xl mx-auto px-6 py-12 bg-white rounded-xl shadow-md">
      {/* Title */}
      <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>

      {/* Intro */}
      <p className="text-gray-700 leading-relaxed mb-6">
        At <strong>MAC LABS LIMITED</strong> ("Company," "we," "our," or "us"),
        we value the privacy of our website visitors, business partners,
        employees, and stakeholders. This Privacy Policy explains how we
        collect, use, store, and protect personal information when you interact
        with our website, products, and services.
      </p>

      {/* Sections */}
      <div className="space-y-6 text-gray-700 leading-relaxed">
        {/* 1 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>
              <strong>Personal Information:</strong> Name, email address, phone
              number, job title, company details, or other identifiers when you
              contact us through our website, email, or enquiry forms.
            </li>
            <li>
              <strong>Business Information:</strong> Company name, regulatory
              documents, supplier or vendor details, and business communications
              related to manufacturing, supply, or distribution.
            </li>
            <li>
              <strong>Technical Information:</strong> IP address, browser type,
              operating system, pages visited, time spent on the website, and
              cookies or similar technologies.
            </li>
            <li>
              <strong>Regulatory & Compliance Data:</strong> Documentation
              required under pharmaceutical, regulatory, or quality standards.
            </li>
          </ul>
        </div>

        {/* 2 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">2. How We Use Information</h2>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>
              To respond to enquiries or requests regarding our APIs,
              intermediates, and formulations.
            </li>
            <li>
              To manage business relationships with suppliers, clients, and
              partners.
            </li>
            <li>
              To comply with legal and regulatory requirements in the
              pharmaceutical industry.
            </li>
            <li>
              To send updates, corporate communications, and information about
              our products and services (where permitted by law).
            </li>
            <li>
              To improve and secure our website, operations, and customer
              experience.
            </li>
          </ul>
        </div>

        {/* 3 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">3. Sharing of Information</h2>
          <p>
            We do not sell, rent, or trade your personal information. However,
            we may share information in the following cases:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>
              With regulatory bodies, auditors, or government authorities in
              compliance with applicable laws.
            </li>
            <li>
              With trusted third-party service providers (e.g., IT support,
              website hosting, regulatory consultants) under strict
              confidentiality obligations.
            </li>
            <li>
              As part of business transfers such as mergers, acquisitions, or
              restructuring.
            </li>
          </ul>
        </div>

        {/* 4 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect information against unauthorized access, alteration,
            disclosure, or destruction. However, no method of transmission over
            the Internet is 100% secure, and we cannot guarantee absolute
            security.
          </p>
        </div>

        {/* 5 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">5. Retention of Data</h2>
          <p>
            We retain personal and business data only as long as necessary to
            fulfil the purposes outlined in this policy or as required by law,
            regulatory authorities, or contractual obligations.
          </p>
        </div>

        {/* 6 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">6. Your Rights</h2>
          <p>Depending on your jurisdiction, you may have the right to:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>
              Access and obtain a copy of the personal data we hold about you.
            </li>
            <li>
              Request corrections, updates, or deletion of inaccurate or
              incomplete information.
            </li>
            <li>
              Object to or restrict the processing of your information in
              certain circumstances.
            </li>
            <li>Withdraw consent where processing is based on prior consent.</li>
          </ul>
          <p className="mt-2">
            To exercise these rights, please contact us at:{" "}
            <span className="font-medium">info@maclabsltd.com</span>.
          </p>
        </div>

        {/* 7 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">7. Cookies & Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar technologies to improve user
            experience, analyze traffic, and customize content. You can manage
            or disable cookies through your browser settings.
          </p>
        </div>

        {/* 8 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">8. Third-Party Links</h2>
          <p>
            Our website may contain links to external websites. We are not
            responsible for the privacy practices of other websites and
            encourage you to review their privacy policies separately.
          </p>
        </div>

        {/* 9 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">9. Children’s Privacy</h2>
          <p>
            Our services are not directed toward individuals under the age of
            18. We do not knowingly collect personal data from minors.
          </p>
        </div>

        {/* 10 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or legal requirements. The revised policy
            will be posted on our website with the updated effective date.
          </p>
        </div>

        {/* 11 */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">11. Contact Us</h2>
          <p>
            If you have any questions or concerns regarding this Privacy Policy
            or our data handling practices, please contact us at{" "}
            <a
              href="mailto:info@maclabsltd.com"
              className="text-blue-600 hover:underline"
            >
              info@maclabsltd.com
            </a>
            .
          </p>
        </div>
      </div>

      {/* Effective Date */}
      <p className="mt-8 text-gray-600 text-sm">
        <strong>Effective Date:</strong> 15-08-2025
      </p>
    </div>
    </div>
  );
}
